import React, { ComponentType } from 'react';
import withLanguage from 'presentation/hocs/withLanguage';

import useStylesheet from './CornerEmbellishments.stylesheet';

export type CornerEmbellishmentsType = {
  topRight?: string;
  bottomRight?: string;
  bottomLeft?: string;
  topLeft?: string;
};
interface OuterProps {
  cornerEmbellishments: CornerEmbellishmentsType;
}

export interface InnerProps extends OuterProps {
  currentLanguage: string;
}
const PureCornerEmbellishments = ({ currentLanguage, cornerEmbellishments }: InnerProps) => {
  const { styles } = useStylesheet({
    currentLanguage,
    cornerEmbellishments,
  });
  return <div style={styles.root} />;
};

PureCornerEmbellishments.displayName = 'CornerEmbellishments';

export default withLanguage(PureCornerEmbellishments) as ComponentType<OuterProps>;
